import { Space, SpaceProps } from "antd"
import React from "react"
import Lottie from "react-lottie"

import Message from "components/Message/Message"
import { Message as MessageType } from "types/redux"

import { Subtitle, Title } from "../Title/Title"
import styles from "./styles.module.scss"

export const Card: React.FC<
  {
    title?: string
    subtitle?: string
    message?: MessageType
    imgUrl?: string
    imgSize?: string
    imgStyle?: React.CSSProperties
    animation?: object
    titleSize?: "large" | "small" | "medium"
    order?: string[]
    titleCustomStyle?: object | undefined
    doNotAnimateTitle?: boolean
    subtitleCustomStyle?: object | undefined
  } & SpaceProps
> = (props): JSX.Element => {
  const { order = ["imgUrl", "title", "subtitle"] } = props
  const sizeClass = props.imgSize === "large"
    ? styles.LargeImg
    : props.imgSize === "medium"
      ? styles.MediumImg
      : props.imgSize
        ? styles.SmallImg
        : undefined
  return (
    <div className={styles.Card} style={props.style}>
      {order.map((element) => {
        if (element === "imgUrl") {
          if (props.animation)
            return (
              <div key={element} className={`${styles.Illustration} ${sizeClass ?? ""}`}>
                <Lottie
                  options={{ animationData: props.animation, loop: true, autoplay: true }}
                  height="100%"
                  width="100%"
                />
              </div>
            )
          if (props.imgUrl)
            return (
              <img
                key={element}
                src={props.imgUrl}
                height={props.imgSize}
                style={props.imgStyle}
                className={`${styles.Illustration} ${sizeClass ?? undefined}`}
                alt={props.title}
              />
            )
        }
        if (element === "title" && props.title)
          return (
            <Title
              key={element}
              size={props.titleSize ?? undefined}
              text={props.title}
              style={props.titleCustomStyle}
              doNotAnimateTitle={props.doNotAnimateTitle}
            />
          )
        if (element === "subtitle" && props.subtitle)
          return <Subtitle key={element} text={props.subtitle} style={props.subtitleCustomStyle} />
        return null
      })}
      <Message message={props.message} />
      <div className={styles.Content}>{props.children}</div>
    </div>
  )
}

export const Buttons: React.FC<SpaceProps> = ({
  children,
  ...rest
}): JSX.Element => {
  if (rest.direction === "vertical")
    return (
      <Space direction="vertical" className={`${styles.Buttons}`} {...rest}>
        {children}
      </Space>
    )
  return (
    <Space
      direction="horizontal"
      size={60}
      {...rest}
      style={{
        paddingTop: "50px",
        justifyContent: "center",
        width: "100%",
        ...rest.style,
      }}
    >
      {children}
    </Space>
  )
}
